<template>
  <section id="search-box">
    <button
      type="button"
      class="close btn-close"
      @click="close"
    >
      <span aria-hidden="true">×</span>
    </button>
    <div class="container">
      <h2 class="font-weight-bold text-color2 font-size-medium">Faça sua busca</h2>
      <form
        action=""
        class="default-form mt-3"
        method="GET"
        @submit.prevent="submit"
      >
        <div class="form-group">
          <input
            type="text"
            class="form-control"
            name="term"
            placeholder="Digite uma palavra chave..."
            v-model="search.term"
            ref="searchInput"
          >
        </div>
      </form>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TheSearchbar',
  props: ['searchVisible'],
  data () {
    return {
      search: {
        term: null
      }
    }
  },
  created () {
    document.addEventListener('keyup', evt => {
      if (evt.key === 'Escape' && this.searchVisible) {
        this.close()
      }
    })
  },
  watch: {
    searchVisible (newValue, oldValue) {
      if (newValue) {
        this.search.term = this.$route.query.term
        this.$refs.searchInput.focus()
      }
    }
  },
  methods: {
    submit () {
      this.$router.push({ name: 'search.show', query: { term: this.search.term } })
      this.close()
    },
    close (e) {
      this.search.term = null
      this.$emit('toggle-search', e)
    }
  }
}
</script>

<style lang="scss" scoped>

#search-box {
  opacity: 0;
  pointer-events: none;
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  z-index: 12;

  form {
    .form-control {
      max-width: 420px;
      margin: 0 auto;
    }
  }

  .btn-close {
    position: absolute;
    top: 18px;
    right: 18px;
  }
}
</style>
